import News1 from "../../assets/images/News1.jpg";
import News10 from "../../assets/images/News10.jpg";
import News11 from "../../assets/images/News11.jpg";
import News12 from "../../assets/images/News12.jpg";
import News13 from "../../assets/images/News13.jpg";
import News14 from "../../assets/images/News14.jpg";
import News15 from "../../assets/images/News15.jpg";
import News16 from "../../assets/images/News16.jpg";
import News17 from "../../assets/images/News17.jpg";
import News18 from "../../assets/images/News18.jpg";
import News2 from "../../assets/images/News2.jpg";
import News3 from "../../assets/images/News3.jpg";
import News4 from "../../assets/images/News4.jpg";
import News5 from "../../assets/images/News5.jpg";
import News7 from "../../assets/images/News7.jpg";
import News8 from "../../assets/images/News8.jpg";
import News9 from "../../assets/images/News9.jpg";
import { useState } from "react";

export const BlogCarousel = () => {
  const [currentSlider, setCurrentSlider] = useState(0);
  const sliders = [
    {
      img: News1,
    },
    {
      img: News2,
    },
    {
      img: News3,
    },
    {
      img: News4,
    },
    {
      img: News5,
    },
    {
      img: News7,
    },
    {
      img: News8,
    },
    {
      img: News9,
    },
    {
      img: News10,
    },
    {
      img: News11,
    },
    {
      img: News12,
    },
    {
      img: News13,
    },
    {
      img: News14,
    },
    {
      img: News15,
    },
    {
      img: News16,
    },
    {
      img: News17,
    },
    {
      img: News18,
    },
  ];

  const prevSlider = () =>
    setCurrentSlider((currentSlider) =>
      currentSlider === 0 ? sliders.length - 1 : currentSlider - 1
    );
  const nextSlider = () =>
    setCurrentSlider((currentSlider) =>
      currentSlider === sliders.length - 1 ? 0 : currentSlider + 1
    );
  return (
    <div className="max-w-6xl mx-auto h-[540px] md:h-[670px] flex flex-col xl:flex-row items-center overflow-hidden gap-5 lg:gap-10 relative">
      <div className="absolute w-full h-full flex items-center justify-between z-50 px-5">
        {/* arrow left */}
        <button
          onClick={prevSlider}
          className="flex justify-center items-center bg-white rounded-full w-6 h-6 md:w-8 md:h-8"
        >
          <svg
            viewBox="0 0 1024 1024"
            className="w-4 h-4 md:w-6 md:h-6 icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="#000000"
          >
            <g strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path
                fill="#0095FF"
                d="M685.248 104.704a64 64 0 010 90.496L368.448 512l316.8 316.8a64 64 0 01-90.496 90.496L232.704 557.248a64 64 0 010-90.496l362.048-362.048a64 64 0 0190.496 0z"
              ></path>
            </g>
          </svg>
        </button>
        {/* arrow right */}
        <button
          onClick={nextSlider}
          className="flex justify-center items-center bg-white rounded-full w-6 h-6 md:w-8 md:h-8"
        >
          <svg
            viewBox="0 0 1024 1024"
            className="w-4 h-4 md:w-6 md:h-6 icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="#000000"
            transform="rotate(180)"
          >
            <g strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path
                fill="#0095FF"
                d="M685.248 104.704a64 64 0 010 90.496L368.448 512l316.8 316.8a64 64 0 01-90.496 90.496L232.704 557.248a64 64 0 010-90.496l362.048-362.048a64 64 0 0190.496 0z"
              ></path>
            </g>
          </svg>
        </button>
      </div>
      {/* slider container */}
      <div
        className="h-[540px] md:h-[670px] w-2/3 ml-auto relative ease-linear duration-300 flex items-center"
        style={{ transform: `translateX(-${currentSlider * 50}%)` }}
      >
        {/* sliders */}
        {sliders.map((slide, inx) => (
          <div
            key={inx}
            className={`${
              currentSlider === inx
                ? "h-[240px] sm:h-[310px] md:h-[480px] lg:h-[580px]"
                : "h-[220px] sm:h-[260px] md:h-[380px] lg:h-[480px] scale-95 opacity-40"
            } min-w-[50%] relative duration-200`}
            style={{ perspective: "200px" }}
          >
            <img
              src={slide.img}
              className="w-full h-full bg-gray-900 rounded-lg duration-300"
              alt={slide.tags}
              style={{
                transform: `${
                  currentSlider - 1 === inx
                    ? "rotateY(4deg)"
                    : currentSlider + 1 === inx
                    ? "rotateY(-4deg)"
                    : ""
                }`,
                transformStyle: "preserve-3d",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
